<template>
  <div>
    <file-list :fileList="fileList"></file-list>
  </div>
</template>

<script>
import fileList from "../../components/fileList";
export default {
  name: "",
  components: { fileList },
  props: {},
  data() {
    return {
      fileList: [
        { name: "申报手册-学校.pdf", byte: "541KB" },
        // { name: "申报手册-中职院校.pdf", byte: "2.2KB" },
        // { name: "申报手册-技工学校.pdf", byte: "1.2KB" },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
